<template>
  <v-app>
    <v-toolbar v-if="checkRoute(['/login'])" flat color="#fff" height="70px">
      <v-toolbar-side-icon @click="toolbar = !toolbar" v-if="role == 2">
        <v-icon>menu</v-icon>
      </v-toolbar-side-icon>
      <p
        class="counter"
        v-if="checkRoute(['/devices', '/add-apk', '/apk', '/merchants', '/merchant_table'])"
      >
        Всего видеороликов:
        <span>{{count}}</span>
      </p>
      <v-spacer></v-spacer>
      <router-link
        to="/add-video"
        class="upload-files"
        v-if="checkRoute(['/devices', '/add-apk', '/apk', '/add-video', '/edit-video', '/merchants', '/merchant_table'])"
      >
        <v-icon color="purple" size="30">cloud_upload</v-icon>
      </router-link>
      <!-- <v-btn :to="/add-video" exact>cloud_upload</v-btn> -->
      <v-divider
        vertical
        v-if="checkRoute(['/devices', '/add-apk', '/apk', '/merchants', '/merchant_table'])"
      ></v-divider>
      <v-toolbar-items>
        <v-btn @click="logout" flat>Logout</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-navigation-drawer
      class="toolbar"
      hide-overlay
      v-model="toolbar"
      absolute
      height="auto"
      width="280"
      temporary
      color="purple"
    >
      <v-list>
        <v-list-tile v-for="item in toolbarItem" :key="item.title" :to="item.link">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <router-view/>
  </v-app>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    role: "",
    toolbar: false,
    count: 0,
    toolbarItem: [
      { title: "Video", icon: "videocam", link: "/videos" },
      { title: "APK", icon: "toc", link: "/apk" },
      { title: "Devices", icon: "devices", link: "/devices" },
      { title: "Merchants", icon: "face", link: "/merchants" },
      { title: "Merchant Table", icon: "attach_money", link: "/merchant_table" }
      // { title: "Transactions", icon: "attach_money", link: "/transactions" }
    ]
  }),
  created() {
    this.role = localStorage.getItem("role");
    console.log(this.role);
    axios
      .get(this.$hostname + "/admin/videos", {
        headers: {
          Authorization: localStorage.getItem("token")
        }
      })
      .then(response => {
        console.log(response);
        let counter = 0;
        response.data.data.forEach(item => {
          if (item.exists) {
            counter++;
          }
        });
        this.count = counter;
        // this.count = response.data.count;
      });
  },
  methods: {
    checkRoute(route) {
      return route.every(link => {
        return !this.$route.path.includes(link);
      });
    },
    logout() {
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss">
.toolbar {
  top: 70px;
  // background-color: lightgrey!important;
}
.v-toolbar {
  z-index: 9;
}
.v-toolbar__content {
  .v-divider {
    &.v-divider--vertical {
      max-height: 50px;
      min-height: inherit;
      margin: auto;
    }
  }
}
.upload-files {
  margin-right: 30px !important;
}
.v-toolbar__items {
  margin-left: 20px;
}
.counter {
  margin: 0;
  margin-left: 40px;
  font-weight: 700;
  font-size: 21px;
  span {
    color: #800057;
  }
}
</style>
